module.exports = __webpack_public_path__ + "img/1f625.2ab9b91.svg";